<template>
  <most-searched />
</template>
<script>
import MostSearched from '../components/client-lms/MostSearched.vue';

export default {
  name: 'MostSearchPage',

  components: {
    MostSearched,
  },
};
</script>
